"use client";
import { Box } from "../../core/Box/Box.mjs";
import { useModalBaseContext } from "./ModalBase.context.mjs";
import { useModalBodyId } from "./use-modal-body-id.mjs";
import ModalBase_module_default from "./ModalBase.module.mjs";
import cx from "clsx";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseBody.tsx
function ModalBaseBody({ className, ...others }) {
	const bodyId = useModalBodyId();
	const ctx = useModalBaseContext();
	return /* @__PURE__ */ jsx(Box, {
		id: bodyId,
		className: cx({ [ModalBase_module_default.body]: !ctx.unstyled }, className),
		...others
	});
}
ModalBaseBody.displayName = "@mantine/core/ModalBaseBody";
//#endregion
export { ModalBaseBody };

//# sourceMappingURL=ModalBaseBody.mjs.map